import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Spin } from "antd";
import SignPdf from "../../../components/pdfSignature/SignPdf";
import LoadableButton from "../../../components/button/LoadableButton";
import {
  GetDocumentApi,
  SubmitSignatureApi,
} from "../../../api/request/dashboard/dashboard";

const SignPdfForMobile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [document, setDocument] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [signedPdf, setSignedPdf] = useState(null);
  const [isUploadFileLoading, setIsUploadFileLoading] = useState(false);
  const [isSignDone, setIsSignDone] = useState(false);

  const getDocumentData = async () => {
    setIsLoading(true);
    try {
      const { data } = await GetDocumentApi(id);
      if (data?.status) {
        setIsSignDone(data?.data?.is_sign_done);
        setDocument(data?.data);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) getDocumentData();
  }, [id]);

  const handleSigningComplete = (signedPdf, signaturePositions) => {
    const isSignPending = signaturePositions.some((item) => !item.signature);
    if (isSignPending) return setSignedPdf(null);
    setSignedPdf(signedPdf);
  };

  const submitSignature = async () => {
    if (!signedPdf) return;
    try {
      setIsUploadFileLoading(true);
      const params = {
        document_id: id,
        file: signedPdf,
      };
      const apiHeader = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      const { data } = await SubmitSignatureApi(params, apiHeader);
      if (data?.status)
        navigate("/success", {
          state: { message: "You have successfully signed the document!" },
        });
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsUploadFileLoading(false);
    }
  };

  return (
    <div className="w-full flex justify-center items-center p-5 md:p-10">
      {isLoading ? (
        <div className="h-screen flex flex-col justify-center items-center gap-2">
          <Spin />
          <p className="text-secondaryLight1">Loading...</p>
        </div>
      ) : (
        <>
          {isSignDone ? (
            <div className="h-screen flex flex-col justify-center items-center gap-2">
              <img src="/assets/images/success.gif" />
              <p className="text-green-500 text-2xl font-semibold">
                Thank You!
              </p>
              <p className="text-secondaryLight1 text-lg text-center">
                You have successfully signed the document!
              </p>
            </div>
          ) : (
            <>
              {document?.path && document?.positions?.length && (
                <div>
                  <div className="max-w-fit overflow-auto">
                    <SignPdf
                      pdfUrl={document?.path}
                      signaturePositions={document?.positions}
                      onSigningComplete={handleSigningComplete}
                    />
                  </div>

                  <div className="mt-5">
                    <LoadableButton
                      type="submit"
                      lable="Upload"
                      isLoading={isUploadFileLoading}
                      loadingLable="Uploading file..."
                      onClick={submitSignature}
                      disabled={!signedPdf}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SignPdfForMobile;
